import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { COURSE_TYPE_NODE_FRAGMENT } from '../fragments'

const SAVE_COURSE_TYPES_MUTATION = gql`
  mutation saveCourseTypes($data: [CourseTypeNodeInput!]!) {
    saveCourseTypes(data: $data) {
      results {
        ...CourseTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${COURSE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_COURSE_TYPES_MUTATION
